var render, staticRenderFns
import script from "./batchAppointForm.vue?vue&type=script&lang=js"
export * from "./batchAppointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0009282",
  null
  
)

export default component.exports